import JWTService from "@/services/jwt.service";
// import Notifier from "@/plugins/notifier";
// import {createApiMethods} from "@/services/api/"
// import store from "@/store";



const plugins = {
  install: (app) => {
    app.mixin({
      computed: {
        $jwt: () => JWTService,
        // $notifier: () => new Notifier(store),
        // $api() {
        //   return createApiMethods(this.$notifier);
        // },
      },
    });
  },
};

export default plugins;